import { CONTACT_ENDED_STATUS } from "../../../constants";
import { logMessage } from "../../../utils/amplifyLogger";
import { clientLog } from "../../../services/logging";
import { setHistoryDialNumberValidateStatus } from "../../../services/history";
import { AppDispatch } from "../../../store/types";

export const dialByPhoneNumber = (
  phoneNumber: string,
  toggleOpenDialPrompt: (() => void) | null = null,
  dispatch: AppDispatch,
) => {
  window.connect.agent((agent: connect.Agent) => {
    const contact = agent.getContacts(window.connect.ContactType.VOICE)[0];
    const status = contact && contact.getStatus();
    if (status && status.type !== CONTACT_ENDED_STATUS) {
      agentCallTransfer(phoneNumber, dispatch);
    } else {
      const endpoint = window.connect.Endpoint.byPhoneNumber(phoneNumber);
      agent.connect(endpoint, {
        success: () => {
          logMessage(`agentCall`, `Dial Phonenumber success`, `info`);
        },
        failure: (err: string) => {
          clientLog({
            component: `agentCall`,
            message: `Dial Phonenumber failed. ${err}`,
          });
          logMessage(`agentCall`, `Dial Phonenumber failed. ${err}`, `error`);
          dispatch(setHistoryDialNumberValidateStatus("failure"));
        },
      });
    }
  });
  if (toggleOpenDialPrompt) {
    toggleOpenDialPrompt();
  }
};

const agentCallTransfer = (phoneNumber: string, dispatch: AppDispatch) => {
  dial(phoneNumber, null, dispatch);
};

export const transferToEndpoint = (
  endpoint: connect.Endpoint,
  dispatch: AppDispatch,
) => {
  dial(null, endpoint, dispatch);
};

const dial = (
  phoneNumber: string | null,
  endpointInfo: connect.Endpoint | null,
  dispatch: AppDispatch,
) => {
  window.connect.agent((agent: connect.Agent) => {
    let endpoint: connect.Endpoint;
    if (phoneNumber) {
      endpoint = window.connect.Endpoint.byPhoneNumber(phoneNumber);
    } else {
      endpoint = endpointInfo as connect.Endpoint;
    }

    agent
      .getContacts(window.connect.ContactType.VOICE)[0]
      .addConnection(endpoint, {
        success: () => {
          logMessage(`agentCall`, `Transfer success`, `info`);
        },
        failure: (err: string) => {
          clientLog({
            component: `agentCall`,
            message: `Transfer failed. ${err}`,
          });
          logMessage(`agentCall`, `Transfer failed. ${err}`, `error`);
          dispatch(setHistoryDialNumberValidateStatus("failure"));
        },
      });
  });
};
